export default __webpack_public_path__ + "static/media/businessname.5fbd1398.png";